import React from "react";

import { LEVELS } from "../level";

export function LevelSelect({
	onSelect,
	onBack,
}: {
	onSelect: (levelIndex: number) => void;
	onBack: () => void;
}) {
	return (
		<div className="App menu-screen menu-screen--wide">
			<h1>RK Beach Rampage</h1>
			<div className="pixel-panel pixel-frame level-select-panel">
				<h2>Select a Level</h2>
				<p className="level-select-hint">A pixel-art tour of Visakhapatnam — ten stops, ten challenges.</p>
				<ul className="level-select-grid">
					{LEVELS.map((level, index) => (
						<li key={level.id}>
							<button className="btn-pixel level-select-card" onClick={() => onSelect(index)}>
								<span className="level-select-number">{index + 1}</span>
								<span className="level-select-name">{level.name}</span>
								<span className="level-select-subtitle">{level.blurb}</span>
							</button>
						</li>
					))}
				</ul>
				<div className="menu-actions">
					<button className="btn-pixel btn-pixel--ghost" onClick={onBack}>
						Back
					</button>
				</div>
			</div>
		</div>
	);
}
